import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import CategoryPresenter from '../../presenters/CategoryPresenter';

import StoreInfoForm from './components/StoreInfoForm';
import Hours from './components/Hours';
import Images from './components/Images';

const StoreForm = (props) => {
  const { errors, values, categories, onChange, storeId } = props;

  const handleIntegerValueChange = ({ target }) => {
    const { id, value } = target;
    const newValue = isEmpty(value) ? null : parseInt(value);

    onChange(id, newValue);
  };

  return (
    <div>
      <StoreInfoForm
        errors={errors}
        values={values}
        categories={categories}
        onChange={onChange}
        onCashbackRateChange={handleIntegerValueChange}
        storeId={storeId}
      />
      <Hours
        errors={errors}
        values={values}
        onChange={handleIntegerValueChange}
      />

      <Images error={errors} brand={values} onChange={onChange} />
    </div>
  );
};

export default StoreForm;

StoreForm.propTypes = {
  errors: PropTypes.shape(),
  values: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(CategoryPresenter.shape()),
  onChange: PropTypes.func.isRequired,
  storeId: PropTypes.string,
};

StoreForm.defaultProps = {
  errors: null,
  categories: [],
  storeId: null,
};
